import React, {useState, useEffect} from 'react'
import RelatedRow from './relatedrow'
import * as relatedsectionStyles from '../../styles/modules/relatedsection.module.less'
import { setRichieParam } from './component-helpers/utilfunctions'
import { appCheck } from 'sfc-utils'
const relatedLinks = require('../../data/links.sheet.json').slice(1);

const RelatedSection = (props) => {
	const isApp = appCheck()
	let [relLinks, setRelLinks] = useState(relatedLinks)
	let section_heading = props.sectionHed ? props.sectionHed : "Read more"
	// Reset in case they need URL params for app
	useEffect(() => {
		if (!isApp){
			setRelLinks(setRichieParam(relLinks))
		}
	}, [])
	// Don't render relateds in app
	if (isApp){
		return null
	}

  return <section aria-label="Related links" className="related-link-wrapper">
	<h4 className={relatedsectionStyles.hed}><span>{section_heading}</span></h4>
    <RelatedRow links={relLinks} />
  </section>
}


export default RelatedSection